<body>
    <div>
        <table class="table2">
            <thead>
                <th class="corlinha">
                    <!-- Janelas <abbr style="color: #0159e6; font-weight: bold;">SLA</abbr> Direto -->
                    Viagens Fluxo Aéreo
                </th>
            </thead>
        </table>
        <div class="table2">
            <!-- <label class="totais">Total Fornecedores: <abbr style="color: #0159e6; font-weight: bold;">{{
                    totalFornecedores }}</abbr></label>       -->
            <button (click)="inserirPlaca()" class="button-spacing newViagem">Inserir Plate</button>
            <button (click)="finalizarViagem()" class="button-spacing finaliza">Finalizar Processos</button>
            <div class="table2">
                <table>
                    <thead>
                        <tr>
                            <th>
                                Selecionar
                            </th>
                            <th>
                                Processo
                            </th>
                            <th>
                                Fatura
                            </th>
                            <th>
                                Aeroporto
                            </th>
                            <th>
                                Partida
                            </th>
                            <th>
                                Chegada
                            </th>
                            <th>
                                Hora
                            </th>
                            <th>
                                Rate
                            </th>

                            <th>
                                Frete
                            </th>
                            <th>
                                HAWB
                            </th>
                            <th>
                                Master
                            </th>
                            <th>
                                Volumes
                            </th>
                            <th>
                                Peso
                            </th>
                            <th>
                                Cubagem M³
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                                Plate
                            </th>
                            <th>
                                Motorista
                            </th>
                            <th>
                                Transportadora
                            </th>
                            <th>
                                Ações
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of viagensFiltradas">
                            <tr>
                                <td>
                                    <input type="checkbox" name="selecionado" [(ngModel)]="item.selecionado"
                                        class="modal-input1">
                                </td>
                                <td>{{ item.processo }}</td>
                                <td>{{ item.fatura }}</td>
                                <td>{{ item.aeroporto }}</td>
                                <td>{{ item.partida }}</td>
                                <td>{{ item.chegada | date: 'dd-MM-yyyy' }}</td>
                                <td>{{ item.hora }}</td>
                                <td>{{ item.rate }}</td>
                                <td>{{ item.frete }}</td>
                                <td>{{ item.hawb }}</td>
                                <td>{{ item.master }}</td>
                                <td>{{ item.Volumes }}</td>
                                <td>{{ item['Weight Loaded'] }}</td>
                                <td>{{ item.Cubage }}</td>
                                <td>{{ item.status }}</td>
                                <td>{{ item.Plate }}</td>
                                <td>{{ item.motorista }}</td>
                                <td>{{ item.transportadora }}</td>
                                <td>
                                    <i-feather name="edit" (click)="editDialog(item)"></i-feather>
                                    <i-feather name="delete" (click)="deleteItem(item)"
                                        class="button-spacing"></i-feather>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">Inserir Plate</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000">
                <tr>
                    <!-- <td class="formPlaca">
                        <label class="modal-label">Transportadora</label>
                        <input type="text" name="transportadora" [(ngModel)]="item.transportadora" class="modal-input1">
                    </td> -->
                    <td class="flex1">
                        <label class="modal-label">Transportadora</label>
                        <select id="transportadoraInput" name="transportadora" [(ngModel)]="item.transportadora"
                            class="modal-select">
                            <option *ngFor="let carrier of carriers" [value]="carrier.name">{{ carrier.name }}</option>
                        </select>
                    </td>
                    <!-- <td class="formPlaca">
                        <label class="modal-label">Plate</label>
                        <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td> -->
                    <td class="formPlaca">
                        <label class="modal-label">Plate</label>
                        <select id="plateInput" name="plate" [(ngModel)]="item.Plate" class="modal-select">
                            <option *ngFor="let veiculo of veiculos" [value]="veiculo.placa">{{
                                veiculo.placa }}
                            </option>
                        </select>
                    </td>
                    <td class="formPlaca">
                        <label class="modal-label">Motorista</label>
                        <input type="text" name="motorista" [(ngModel)]="item.motorista" class="modal-input1">
                    </td>
                </tr>
            </table>
            <div class="modal-div">
                <button *ngIf="!edit" class="modal-button" type="button" (click)="salvarNoBanco()">Save</button>
                <button *ngIf="edit" class="modal-button" type="button" (click)="salvar2(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>